import { env } from 'next-runtime-env';

/**
 * Don't send OTP emails (or require OTP) for non ouraring.com emails
 * in local, sandbox, or staging.
 * This will help ensure we don't accidentally send OTP emails
 * to external email addresses in our lower envs.
 */

export const ALLOWED_TEST_DOMAINS = ['ouraring.com', 'lifering.hu'];

export const shouldAuthenticate = (email: string | null) => {
  // send OTP for everyone in prod
  if (env('NEXT_PUBLIC_OURA_ENV') === 'production') {
    return true;
  }

  // for testing ???
  if (!email) {
    return true;
  }

  // sent OTP for allowed domains
  const domain = email.split('@').pop();
  if (domain && ALLOWED_TEST_DOMAINS.includes(domain)) {
    return true;
  }

  return false;
};
